import { v4 as uuidv4 } from 'uuid';
import { Order, OrderItem } from '../types/order';
import { Client, IndividualClient } from '../types/client';

// Real Manitoba addresses from Winnipeg, Steinbach, and towns between
const MANITOBA_ADDRESSES = [
  // Winnipeg addresses
  { street: '123 Main Street', city: 'Winnipeg', postalCode: 'R3C 1A5' },
  { street: '456 Portage Avenue', city: 'Winnipeg', postalCode: 'R3B 2E7' },
  { street: '789 Broadway', city: 'Winnipeg', postalCode: 'R3C 0V8' },
  { street: '321 Henderson Highway', city: 'Winnipeg', postalCode: 'R2L 1L8' },
  { street: '654 Pembina Highway', city: 'Winnipeg', postalCode: 'R3M 2M7' },
  { street: '987 Corydon Avenue', city: 'Winnipeg', postalCode: 'R3M 0Y3' },
  { street: '147 Osborne Street', city: 'Winnipeg', postalCode: 'R3L 1Y5' },
  { street: "258 St. Mary's Road", city: 'Winnipeg', postalCode: 'R2M 3L4' },
  { street: '369 Notre Dame Avenue', city: 'Winnipeg', postalCode: 'R3B 1R5' },
  { street: '741 Stafford Street', city: 'Winnipeg', postalCode: 'R3M 2X2' },
  { street: '852 Sargent Avenue', city: 'Winnipeg', postalCode: 'R3E 0B7' },
  { street: '963 McPhillips Street', city: 'Winnipeg', postalCode: 'R2X 2H3' },
  { street: '159 Regent Avenue West', city: 'Winnipeg', postalCode: 'R2C 1R1' },
  { street: '357 Ellice Avenue', city: 'Winnipeg', postalCode: 'R3G 0B1' },
  { street: '486 St. James Street', city: 'Winnipeg', postalCode: 'R3G 3J6' },
  { street: '753 Logan Avenue', city: 'Winnipeg', postalCode: 'R3E 1S3' },
  { street: '246 Isabel Street', city: 'Winnipeg', postalCode: 'R3A 1G7' },
  { street: '135 Graham Avenue', city: 'Winnipeg', postalCode: 'R3C 0M4' },
  { street: '579 Donald Street', city: 'Winnipeg', postalCode: 'R3B 2J2' },
  { street: '864 Fort Street', city: 'Winnipeg', postalCode: 'R3G 0M2' },

  // Steinbach addresses
  { street: '125 Main Street', city: 'Steinbach', postalCode: 'R5G 1Y7' },
  { street: '234 PTH 12 North', city: 'Steinbach', postalCode: 'R5G 1T5' },
  { street: '456 Reimer Avenue', city: 'Steinbach', postalCode: 'R5G 0H3' },
  { street: '789 Brandt Street', city: 'Steinbach', postalCode: 'R5G 0C2' },
  { street: '321 Lumber Avenue', city: 'Steinbach', postalCode: 'R5G 1Z2' },
  { street: '654 Henry Street', city: 'Steinbach', postalCode: 'R5G 1W8' },
  { street: '987 McKenzie Avenue', city: 'Steinbach', postalCode: 'R5G 0N1' },
  { street: '147 Clearspring Road', city: 'Steinbach', postalCode: 'R5G 1M5' },

  // Lorette (between Winnipeg and Steinbach)
  { street: '234 Main Street', city: 'Lorette', postalCode: 'R0A 0Z0' },
  { street: '456 Railway Avenue', city: 'Lorette', postalCode: 'R0A 0Z0' },

  // Niverville (between Winnipeg and Steinbach)
  { street: '123 Main Street', city: 'Niverville', postalCode: 'R0A 1E0' },
  { street: '345 Fifth Avenue South', city: 'Niverville', postalCode: 'R0A 1E0' },
  { street: '567 Krahn Road', city: 'Niverville', postalCode: 'R0A 1E0' },

  // Ile des Chenes
  { street: '789 Dawson Road', city: 'Ile des Chenes', postalCode: 'R0A 0T0' },
  { street: '234 Main Street', city: 'Ile des Chenes', postalCode: 'R0A 0T0' },

  // Grunthal (near Steinbach)
  { street: '123 Main Street', city: 'Grunthal', postalCode: 'R0A 0R0' },
  { street: '456 PTH 12', city: 'Grunthal', postalCode: 'R0A 0R0' },

  // Blumenort (near Steinbach)
  { street: '234 Main Street', city: 'Blumenort', postalCode: 'R0A 0C0' },
  { street: '567 Church Avenue', city: 'Blumenort', postalCode: 'R0A 0C0' },

  // La Broquerie (southeast)
  { street: '123 Principale Street', city: 'La Broquerie', postalCode: 'R0A 0W0' },
  { street: '345 Dawson Road', city: 'La Broquerie', postalCode: 'R0A 0W0' }
];

// Common Canadian first names
const FIRST_NAMES = [
  'James',
  'Mary',
  'John',
  'Patricia',
  'Robert',
  'Jennifer',
  'Michael',
  'Linda',
  'William',
  'Elizabeth',
  'David',
  'Barbara',
  'Richard',
  'Susan',
  'Joseph',
  'Jessica',
  'Thomas',
  'Sarah',
  'Christopher',
  'Karen',
  'Charles',
  'Lisa',
  'Daniel',
  'Nancy',
  'Matthew',
  'Betty',
  'Anthony',
  'Margaret',
  'Mark',
  'Sandra',
  'Donald',
  'Ashley',
  'Steven',
  'Emily',
  'Andrew',
  'Kimberly',
  'Paul',
  'Donna',
  'Joshua',
  'Michelle',
  'Kenneth',
  'Carol',
  'Kevin',
  'Amanda',
  'Brian',
  'Melissa',
  'George',
  'Deborah',
  'Timothy',
  'Stephanie',
  'Ronald',
  'Dorothy',
  'Edward',
  'Rebecca',
  'Jason',
  'Sharon',
  'Jeffrey',
  'Laura',
  'Ryan',
  'Cynthia',
  'Jacob',
  'Amy',
  'Gary',
  'Kathleen'
];

// Common Canadian last names
const LAST_NAMES = [
  'Smith',
  'Johnson',
  'Williams',
  'Brown',
  'Jones',
  'Garcia',
  'Miller',
  'Davis',
  'Rodriguez',
  'Martinez',
  'Hernandez',
  'Lopez',
  'Gonzalez',
  'Wilson',
  'Anderson',
  'Thomas',
  'Taylor',
  'Moore',
  'Jackson',
  'Martin',
  'Lee',
  'Thompson',
  'White',
  'Harris',
  'Sanchez',
  'Clark',
  'Ramirez',
  'Lewis',
  'Robinson',
  'Walker',
  'Young',
  'Allen',
  'King',
  'Wright',
  'Scott',
  'Torres',
  'Nguyen',
  'Hill',
  'Flores',
  'Green',
  'Adams',
  'Nelson',
  'Baker',
  'Hall',
  'Rivera',
  'Campbell',
  'Mitchell',
  'Carter',
  'Roberts',
  'Gomez',
  'Phillips',
  'Evans',
  'Turner',
  'Diaz',
  'Parker',
  'Cruz',
  'Edwards',
  'Collins',
  'Reyes',
  'Stewart',
  'Morris',
  'Morales',
  'Murphy',
  'Cook'
];

/**
 * Generates a random customer name
 */
function generateRandomName(): string {
  const firstName = FIRST_NAMES[Math.floor(Math.random() * FIRST_NAMES.length)];
  const lastName = LAST_NAMES[Math.floor(Math.random() * LAST_NAMES.length)];
  return `${firstName} ${lastName}`;
}

/**
 * Generates a random email based on a name
 */
function generateRandomEmail(name: string): string {
  const domains = ['gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'icloud.com'];
  const sanitizedName = name.toLowerCase().replace(/\s+/g, '.');
  const domain = domains[Math.floor(Math.random() * domains.length)];
  return `${sanitizedName}@${domain}`;
}

/**
 * Generates a random Manitoba phone number with 204 area code
 */
function generateRandomPhone(): string {
  const exchange = Math.floor(Math.random() * 900) + 100; // 100-999
  const lineNumber = Math.floor(Math.random() * 9000) + 1000; // 1000-9999
  return `204-${exchange}-${lineNumber}`;
}

/**
 * Generates a random date within the last N days
 */
function generateRandomDate(daysAgo: number): string {
  const today = new Date();
  const randomDays = Math.floor(Math.random() * daysAgo);
  const date = new Date(today);
  date.setDate(date.getDate() - randomDays);
  return date.toISOString().split('T')[0];
}

/**
 * Gets a random address from the Manitoba addresses list
 */
function getRandomAddress() {
  return MANITOBA_ADDRESSES[Math.floor(Math.random() * MANITOBA_ADDRESSES.length)];
}

/**
 * Gets a random subset of recipes
 */
function getRandomRecipes(
  availableRecipes: Array<{ id: string; name: string }>,
  count: number
): Array<{ id: string; name: string }> {
  const shuffled = [...availableRecipes].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, availableRecipes.length));
}

/**
 * Generates a random quantity between min and max (inclusive)
 */
function randomQuantity(min: number = 1, max: number = 10): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Generates random order items (1-2 items per order)
 */
function generateOrderItems(availableRecipes: Array<{ id: string; name: string }>): OrderItem[] {
  if (availableRecipes.length === 0) {
    return [];
  }

  const itemCount = Math.random() < 0.5 ? 1 : 2; // 50% chance of 1 or 2 items
  const selectedRecipes = getRandomRecipes(availableRecipes, itemCount);

  return selectedRecipes.map(recipe => ({
    id: uuidv4(),
    recipeId: recipe.id,
    recipeName: recipe.name,
    quantity: randomQuantity(1, 10)
  }));
}

/**
 * Generates a single test order with random data
 * Note: This creates a standalone order with a temporary clientId.
 * For creating orders with proper client records, use generateTestOrderWithClient instead.
 */
export function generateTestOrder(availableRecipes: Array<{ id: string; name: string }>): Order {
  const customerName = generateRandomName();
  const address = getRandomAddress();
  const deliveryType = Math.random() < 0.8 ? 'Delivery' : 'Pickup'; // 80% Delivery, 20% Pickup

  return {
    id: uuidv4(),
    customerName,
    customerType: Math.random() < 0.7 ? 'Individual' : 'Retailer', // 70% Individual, 30% Retailer
    email: generateRandomEmail(customerName),
    phone: generateRandomPhone(),
    streetAddress: address.street,
    addressLine2: '',
    city: address.city,
    province: 'Manitoba',
    postalCode: address.postalCode,
    orderDate: generateRandomDate(10), // Random date within last 10 days
    deliveryType,
    items: generateOrderItems(availableRecipes),
    status: 'Pending',
    isFinalized: false, // Will be finalized through inventory check
    clientId: uuidv4() // Temporary clientId - should be replaced with actual client
  };
}

/**
 * Generates a single test order with a linked client
 * Returns both the order and the client
 */
export function generateTestOrderWithClient(availableRecipes: Array<{ id: string; name: string }>): {
  order: Order;
  client: Client;
} {
  const customerName = generateRandomName();
  const address = getRandomAddress();
  const deliveryType = Math.random() < 0.8 ? 'Delivery' : 'Pickup';
  const clientId = uuidv4();
  const email = generateRandomEmail(customerName);
  const phone = generateRandomPhone();

  const client: IndividualClient = {
    id: clientId,
    type: 'individual',
    name: customerName,
    email: email,
    phone: phone,
    address: `${address.street}, ${address.city}, Manitoba ${address.postalCode}`,
    notes: 'Auto-generated test client',
    preferences: '',
    createdAt: new Date().toISOString()
  };

  const order: Order = {
    id: uuidv4(),
    customerName,
    customerType: Math.random() < 0.7 ? 'Individual' : 'Retailer', // 70% Individual, 30% Retailer
    email,
    phone,
    streetAddress: address.street,
    addressLine2: '',
    city: address.city,
    province: 'Manitoba',
    postalCode: address.postalCode,
    orderDate: generateRandomDate(10),
    deliveryType,
    items: generateOrderItems(availableRecipes),
    status: 'Pending',
    isFinalized: false, // Will be finalized through inventory check
    clientId: clientId
  };

  return { order, client };
}

/**
 * Generates multiple test orders (legacy - for backwards compatibility)
 */
export function generateMultipleTestOrders(
  count: number,
  availableRecipes: Array<{ id: string; name: string }>
): Order[] {
  const orders: Order[] = [];

  for (let i = 0; i < count; i++) {
    orders.push(generateTestOrder(availableRecipes));
  }

  return orders;
}

/**
 * Generates multiple test orders with linked clients
 * Returns arrays of both orders and clients
 */
export function generateMultipleTestOrdersWithClients(
  count: number,
  availableRecipes: Array<{ id: string; name: string }>
): Array<{ order: Order; client: Client }> {
  const results: Array<{ order: Order; client: Client }> = [];

  for (let i = 0; i < count; i++) {
    results.push(generateTestOrderWithClient(availableRecipes));
  }

  return results;
}
